/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargo_EditInputs */

const en_cargo_edit = /** @type {(inputs: Cargo_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Cargo`)
};

const es_cargo_edit = /** @type {(inputs: Cargo_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar carga`)
};

/**
* | output |
* | --- |
* | "Edit Cargo" |
*
* @param {Cargo_EditInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargo_edit = /** @type {((inputs?: Cargo_EditInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargo_EditInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargo_edit(inputs)
	return es_cargo_edit(inputs)
});